import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticatedGuard } from './routing-guard';

import { AdoptionRequestComponent } from '../app/adoptionrequest/adoptionrequest.component';
import { ClasslinkSSOLoginComponent } from '../app/classlink/classlink.component';
import { CollegeStudentSearchComponent } from '../app/collegestudentsearch/collegestudentsearch.component';
import { HomeComponent } from '../app/home/home.component';
import { IssueAlertComponent } from '../app/issuealert/issuealert.component';
import { IssueReportComponent } from '../app/issuereport/issuereport.component';
import { IssueReportReviewComponent } from '../app/issuereportreview/issuereportreview.component';
import { LoginComponent } from '../app/login/login.component';
import { ManageAdoptionsComponent } from '../app/manageadoptions/manageadoptions.component';
import { ManageCoursesComponent } from '../app/managecourses/managecourses.component';
import { ManageDesigneesComponent } from '../app/managedesignees/managedesignees.component';
import { ManageScoresComponent } from '../app/managescores/managescores.component';
import { ManageStaffComponent } from '../app/managestaff/managestaff.component';
import { ManageTermsComponent } from '../app/manageterms/manageterms.component';
import { OfflineComponent } from '../app/offline/offline.component';
import { OldRequestsComponent } from '../app/oldrequests/oldrequests.component';
import { ParentContactComponent } from '../app/parentcontact/parentcontact.component';
import { ReportsComponent } from '../app/reports/reports.component';
import { RequestsComponent } from '../app/requests/requests.component';
import { SSOLoginComponent } from '../app/ssologin/ssologin.component';
import { StudentContactComponent } from '../app/studentcontact/studentcontact.component';
import { StudentSearchComponent } from '../app/studentsearch/studentsearch.component';
import { StudentSelectComponent } from '../app/studentselect/studentselect.component';
import { PageNotFoundComponent } from '../app/pagenotfound/pagenotfound.component';
import { AdminSettingsComponent } from '../app/admin-settings/admin-settings.component';

const routes: Routes = [
    {
        path: 'offline',
        component: OfflineComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'classlink',
        component: ClasslinkSSOLoginComponent,
    },
    {
        path: 'focussso',
        component: SSOLoginComponent,
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['all'] },
    },
    {
        path: 'studentselect',
        component: StudentSelectComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['parent'] },
    },
    {
        path: 'parentcontact',
        component: ParentContactComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['parent'] },
    },
    {
        path: 'studentcontact',
        component: StudentContactComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['student'] },
    },
    {
        path: 'adminsettings',
        component: AdminSettingsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['developer'] },
    },
    {
        path: 'adoptionrequest/:CollegeCourseID',
        component: AdoptionRequestComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['counselor', 'schooladmin'] },
    },
    {
        path: 'adoptionrequest',
        component: AdoptionRequestComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['counselor', 'schooladmin'] },
    },
    {
        path: 'studentrecordview/:RecordID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['all'] },  //TODO
    },
    {
        path: 'studentrecordview/:StudentID/:RecordID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['all'] },  //TODO
    },
    {
        path: 'studentsearch',
        component: StudentSearchComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['counselor', 'schooladmin', 'districtadmin', 'developer'] },
    },
    {
        path: 'collegestudentsearch',
        component: CollegeStudentSearchComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['advisor', 'collegeadmin', 'collegesupport'] },
    },
    {
        path: 'manageadoptions',
        component: ManageAdoptionsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['districtadmin', 'developer'] },
    },
    {
        path: 'managescores',
        component: ManageScoresComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['districtadmin', 'developer'] },
    },
    {
        path: 'managestaff',
        component: ManageStaffComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['collegeadmin', 'districtadmin', 'developer'] },
    },
    {
        path: 'manageterms',
        component: ManageTermsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['collegeadmin', 'districtadmin', 'developer'] },
    },
    {
        path: 'managecourses',
        component: ManageCoursesComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['districtadmin', 'developer'] },
    },
    {
        path: 'managedesignees',
        component: ManageDesigneesComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['districtadmin', 'developer'] },
    },
    {
        path: 'issuealert',
        component: IssueAlertComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['developer'] },
    },
    // NOTE: Temporarily diabled this route until tool can be linked to IIQ
    // {
    //     path: 'issuereport',
    //     component: IssueReportComponent,
    //     canActivate: [AuthenticatedGuard],
    //     data: { roles: ['all'] },
    // },
    {
        path: 'issuereporttracker',
        component: IssueReportReviewComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['districtadmin', 'developer'] },
    },
    {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['counselor', 'schooladmin', 'districtadmin', 'advisor', 'collegeadmin', 'collegesupport', 'developer'] },
    },
    {
        path: 'studentview',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['student'] },
    },
    {
        path: 'studentview/:StudentID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['all'] },
    },
    {
        path: 'studentview/:RecordID/:StudentID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['all'] },
    },
    {
        path: 'studentviewbyyear/:StudentID/:SchoolYear',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: { roles: ['all'] },
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/home', // Update as needed
    },
    { path: '**', component: PageNotFoundComponent },  // Wildcard route for a 404 page
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/routes/app-routing.module.ts